import { formatDate } from '@src/libs/date-fns'

import {
  CardTransactionsDetails,
  CardUsersDetails,
  CardsDetails,
  CardsTransactionsDetails,
  UserCardsTransactionsDetails,
} from './type'

export const PATHS = {
  ROOT: '/',
  ACCOUNTING: '/accounting',
  CARDS: '/cards',
  CARDS_USERS: '/cards/users',
  CARDS_ISSUE_TO_ISSUE_NEW_CARD: '/cards/issue/to-issue-new-card/',
  CARDS_ISSUE: '/cards/issue',
  CARDS_ISSUE_ON_DEMAND: '/cards/issue/on-demand',
  CARDS_ISSUE_VIRTUAL: '/cards/issue/virtual',
  CARDS_ISSUE_SELECT_TYPE: '/cards/issue/select-type',
  CARDS_ISSUE_PHYSICAL: '/cards/issue/physical',
  CARDS_ISSUE_METAL: '/cards/issue/metal',
  CARDS_USERS_DETAILS: ({
    userAccountId,
    yearMonth = formatDate(new Date(), {
      dateFormat: 'yyyyMM',
    }),
  }: CardUsersDetails) =>
    `/cards/users/${userAccountId}?yearMonth=${yearMonth}`,
  CARDS_TRANSACTIONS_DETAILS: ({
    userAccountId,
    transactionId,
    yearMonth = formatDate(new Date(), {
      dateFormat: 'yyyyMM',
    }),
  }: CardTransactionsDetails) =>
    `/cards/users/${userAccountId}/transactions/${transactionId}?yearMonth=${yearMonth}`,
  CARDS_TRANSACTIONS_DETAILS_WITH_TO_YEAR_MONTH: ({
    userAccountId,
    transactionId,
    toYearMonth,
  }: CardsTransactionsDetails) =>
    `/cards/users/${userAccountId}/transactions/${transactionId}?toYearMonth=${toYearMonth}`,
  CARDS_DETAILS: ({
    userAccountId,
    yearMonth = formatDate(new Date(), {
      dateFormat: 'yyyyMM',
    }),
  }: CardsDetails) => `/cards/users/${userAccountId}?yearMonth=${yearMonth}`,
  USER_CARDS_DETAILS: ({
    userAccountId,
    yearMonth = formatDate(new Date(), {
      dateFormat: 'yyyyMM',
    }),
  }: CardsDetails) => `/user-cards/${userAccountId}?yearMonth=${yearMonth}`,
  USER_CARDS_TRANSACTIONS_DETAILS: ({
    userAccountId,
    transactionId,
    toYearMonth,
  }: UserCardsTransactionsDetails) =>
    `/user-cards/${userAccountId}/transactions/${transactionId}${
      toYearMonth ? `?toYearMonth=${toYearMonth}` : ''
    }`,
  DOCUMENTS_PRIVACY_POLICY: '/public/privacy-policy',
  DOCUMENTS_TERMS: '/public/terms',
  EVIDENCES: '/evidences',
  MESSAGES: '/messages',
  MESSAGE_DETAIL: (messageId: number) => `/messages/${messageId}`,
  MERCHANTS: '/merchants',
  PAYMENTS: '/payments',
  PURCHASE_APPLICATIONS_ALL: '/purchase-applications/all',
  PURCHASE_APPLICATIONS_CREATE_AFTER_TRANSACTION:
    '/purchase-applications/create/after-transaction',
  PURCHASE_APPLICATIONS_CREATE_BEFORE_TRANSACTION:
    '/purchase-applications/create/before-transaction',
  PURCHASE_APPLICATIONS_EXPECT_MYSELF:
    '/purchase-applications/except-myself-list/approval-request',
  PURCHASE_APPLICATIONS_MYSELF: '/purchase-applications/myself-list',
  PURCHASE_APPLICATIONS_TEMPLATE: '/purchase-applications/template',
  PURCHASE_APPLICATIONS_TEMPLATE_CREATE:
    '/purchase-applications/template/create',
  PURCHASE_APPLICATIONS_DETAIL: (applicationId: string) =>
    `/purchase-applications/${applicationId}`,
  REGISTER_PASSWORD: '/register-password',
  RESET_PASSWORD: '/reset-password',
  REWARDS: '/rewards',
  SETTINGS_ACCOUNT: '/settings',
  SETTINGS_ACCOUNTING: '/settings/accounting',
  SETTINGS_ACCOUNTING_INTEGRATION_EDIT: '/settings/accounting/integration/edit',
  SETTINGS_ACCOUNTING_TRANSACTION_END_DATE:
    '/settings/accounting/transaction-end-date/edit',
  SETTINGS_ACCOUNTING_JOURNAL_START_DATE:
    '/settings/accounting/journal-start-date/edit',
  SETTINGS_ACCOUNTING_POINT_ACCOUNT_EDIT:
    '/settings/accounting/point-account/edit',
  SETTINGS_ACCOUNTING_FREEE_REGISTER: '/settings/accounting/freee/register',
  SETTINGS_AI_COWORKER: '/settings/ai-coworker',
  SETTINGS_AI_COWORKER_PERSONALITY: '/settings/ai-coworker/personality',
  SETTINGS_AI_COWORKER_EMPLOYEE: '/settings/ai-coworker/employee',
  SETTINGS_AI_COWORKER_WORKFLOW: '/settings/ai-coworker/workflow',
  SETTINGS_ACCOUNTING_DISPLAY: '/settings/accounting/display',
  SETTINGS_CARD_ROLE: '/cards/settings/role',
  SETTINGS_COMPANY: '/settings/company',
  SETTINGS_COMPANY_MONEYTREE_AUTH_PROCESSING:
    '/settings/company/moneytree/auth/processing',
  SETTINGS_EDIT_EMAIL: '/settings/email/edit',
  SETTINGS_EDIT_USER_NAME: '/settings/name/edit',
  SETTINGS_EMAIL_CONFIRM: '/settings/email/confirm',
  SETTINGS_EMAIL_NOTIFICATION: '/settings/email-notification',
  SETTINGS_IDENTIFICATION: '/settings/identification',
  SETTINGS_MEMO_TEMPLATE: '/settings/memo-templates',
  SETTINGS_SLACK_NOTIFICATION: '/settings/slack-notification',
  SETTINGS_SLACK_NOTIFICATION_TRANSACTION:
    '/settings/slack-notification/transaction',
  SETTINGS_SLACK_NOTIFICATION_TRANSACTION_DETAILS: ({
    channelId,
  }: {
    channelId: string
  }) => `/settings/slack-notification/transaction/${channelId}`,
  SETTINGS_SLACK_NOTIFICATION_EVIDENCE_REMIND_DETAILS: ({
    channelId,
  }: {
    channelId: string
  }) => `/settings/slack-notification/evidence-remind/${channelId}`,
  SETTINGS_TEAMS_NOTIFICATION: '/settings/teams-notification',
  SETTINGS_TEAMS_NOTIFICATION_TRANSACTION:
    '/settings/teams-notification/transaction',
  SETTINGS_TEAMS_NOTIFICATION_TRANSACTION_DETAILS: ({
    channelId,
  }: {
    channelId: string
  }) => `/settings/teams-notification/transaction/${channelId}`,
  SETTINGS_TFA_COMPLETE: '/settings/tfa/complete',
  SETTINGS_TFA: '/settings/tfa',
  SETTINGS_EDIT_PASSWORD: '/settings/password/edit',
  SETTINGS_SSO: '/settings/sso',
  SIGNIN: '/signin',
  TRANSACTIONS: '/transactions',
  USERS: '/users',
  USER_CARDS: '/user-cards',
  USER_CARDS_PURCHASE_APPLICATIONS_CREATE_AFTER_TRANSACTION:
    '/user-cards/purchase-applications/create/after-transaction',
  USER_CARDS_PURCHASE_APPLICATIONS_CREATE_BEFORE_TRANSACTION:
    '/user-cards/purchase-applications/create/before-transaction',
  USER_CARDS_PURCHASE_APPLICATIONS_EXPECT_MYSELF:
    '/user-cards/purchase-applications/except-myself-list/approval-request',
  USER_CARDS_PURCHASE_APPLICATIONS_MYSELF:
    '/user-cards/purchase-applications/myself-list',
  USER_CARDS_PURCHASE_APPLICATIONS_TEMPLATE:
    '/user-cards/purchase-applications/template',
  USER_CARDS_TRANSACTIONS: '/user-cards/transactions',
  WALLET: '/wallet',
  TFA_APP_PATH: '/settings/tfa/app',
  TFA_SMS_PATH: '/settings/tfa/sms',
  DEACTIVATE_TFA: '/deactivate-tfa',
  PAYMENTS_CREATE_TRANSFER: '/payments/create/transfer',
  PAYMENTS_APPLICATIONS: '/payments/applications',
  PAYMENTS_LIST: '/payments/list',
  PAYMENTS_LIST_DETAIL: (paymentId: string) => `/payments/list?id=${paymentId}`,
  PAYMENTS_TRANSFERS: '/payments/transfers',
  PAYMENTS_TRANSFERS_DETAIL: (transferId: string) =>
    `/payments/transfers/${transferId}`,
  PAYMENTS_TRENDS: '/payments/trends',
  GUARANTEE_MONEY_DEPOSITS_EXPIRY: '/wallet/guarantee-money-deposits/expiry',
  ERROR_NOT_FOUND: '/error/404',
  CARD_BILLS_DETAIL: (cardBillId: string) => `/card-bills/${cardBillId}`,
  SIGNIN_TFA_RECOVERY_CODE: '/signin/tfa/recovery-code',
  SIGNIN_TFA_APP: '/signin/tfa/app',
  SIGNIN_TFA_SMS: '/signin/tfa/sms',
  GRANT_CODE_TEST: '/signin/grant-code-test',
  OAUTH_CALLBACK_TEST: '/signin/oauth-callback-test',
  INVOKE_REDIRECT_WEB: '/invoke/redirect/web',
  APP: '/public/mobile-app',
  ACTIVITIES: (activityId: string) => `/activities/${activityId}`,
  USAGE_FEES: (usageFeeId: string) => `/usage-fees/${usageFeeId}`,
  CARD_BILLS: (cardBillId: string) => `/card-bills/${cardBillId}`,
  INVOICE_PDF_LIST: '/invoice-pdf-list',
  OAUTH_AUTHORIZE_ACCEPT: '/oauth/authorize/accept',
  OAUTH_CONSENT_ACCEPT: '/oauth/consent/accept',
  OAUTH_CONSENT_DECLINE: '/oauth/consent/decline',
  OAUTH_CONSENT: '/oauth/consent',
  ZEUS: '/zeus',
  ZEUS_ORGANIZATIONS_BLOCKS: '/zeus/organizations/blocks',
  ZEUS_ORGANIZATIONS_BLOCKS_NEW: '/zeus/organizations/blocks/new',
  ZEUS_ORGANIZATIONS_BLOCKS_DETAIL: (organizationId: string) =>
    `/zeus/organizations/blocks/${organizationId}/detail`,
  ZEUS_ORGANIZATIONS_BLOCKS_NEW_MERCHANT: (organizationId: string) =>
    `/zeus/organizations/blocks/${organizationId}/merchant/new`,
  ZEUS_ORGANIZATIONS_BLOCKS_EDIT: (
    organizationId: string,
    merchantOrgBlockListId: string
  ) =>
    `/zeus/organizations/blocks/${organizationId}/edit/${merchantOrgBlockListId}`,
  ZEUS_BLOCKS: '/zeus/blocks',
  ZEUS_BLOCKS_NEW: '/zeus/blocks/new',
  ZEUS_BLOCKS_DETAIL: (merchantGeneralBlockListId: string) =>
    `/zeus/blocks/${merchantGeneralBlockListId}/detail`,
  ZEUS_BLOCKS_EDIT: (merchantGeneralBlockListId: string) =>
    `/zeus/blocks/${merchantGeneralBlockListId}/edit`,
  ZEUS_BLOCKS_NEW_WHITE_LIST: (merchantGeneralBlockListId: string) =>
    `/zeus/blocks/${merchantGeneralBlockListId}/white-list/new`,
  PUBLIC_CREATE_ACCOUNT: '/public/create-account',
  PUBLIC_CREATE_ACCOUNT_SIGNIN: '/public/create-account/signin',
  PUBLIC_CREATE_ACCOUNT_EXPIRED: '/public/create-account/expired',
  PUBLIC_CREATE_ACCOUNT_IDENTIFICATION: '/public/create-account/identification',
  PUBLIC_CREATE_ACCOUNT_INPUT_COMPLETE: '/public/create-account/input-complete',
  PUBLIC_CREATE_ACCOUNT_COMPLETE: '/public/create-account/complete',
  ZEUS_GUARANTEE_MONEY: '/zeus/guarantee-money',
  ZEUS_ORGANIZATIONS: '/zeus/organizations',
  ZEUS_ORGANIZATIONS_DETAIL: (organizationId: string) =>
    `/zeus/organizations/${organizationId}`,
  CREATE_ANOTHER_COMPANY: '/lp/application.html',
  PUBLIC_EKYC_UPLOAD: (identificationId: string) =>
    `/public/ekyc/upload/?id=${identificationId}`,
  PUBLIC_EKYC_UPLOAD_INTERNAL: '/public/ekyc/upload/internal',
  PUBLIC_EKYC_EXPIRED: '/public/ekyc/expired',
  PUBLIC_EKYC_COMPLETE: '/public/ekyc/complete',
  PUBLIC_EKYC_AWAITING_POSTCARD: '/public/ekyc/awaiting-postcard',
  PUBLIC_CREATE_IDENTIFICATION_INTERNAL:
    '/public/create-account/identification/internal',
  PUBLIC_CREATE_ACCOUNT_AWAITING_POSTCARD:
    '/public/create-account/awaiting-postcard',
  PUBLIC_TERMS: '/public/terms',
  PUBLIC_PRIVACY_POLICY: '/public/privacy-policy',
  ZEUS_ORGANIZATIONS_CREATE_REQUESTS: '/zeus/organization-create-requests',
  ZEUS_ORGANIZATION_CREATE_REQUESTS_DETAIL: (
    organizationCreateRequestsId: string
  ) =>
    `/zeus/organizations/new/?organizationCreateRequestId=${organizationCreateRequestsId}`,
  ZEUS_ONBOARDING_REQUESTS: '/zeus/onboarding-requests',
  ZEUS_ONBOARDING_REQUESTS_DETAIL: (onboardingRequestId: string) =>
    `/zeus/onboarding-requests/${onboardingRequestId}`,
  ZEUS_CREATE_ACCOUNT_BY_FACE_TO_FACE: '/zeus/create-account-by-face-to-face',
  ZEUS_ONBOARDING_REQUESTS_DETAIL_FACE_TO_FACE_UPLOAD_IDENTITY_DOCUMENT: (
    onboardingRequestId: string
  ) =>
    `/zeus/onboarding-requests/${onboardingRequestId}/face-to-face/upload-identity-document`,
}
